import { FormGroup } from '@angular/forms';
import { Pagination } from './pagination';
import { Crop } from './crop';
import { Farm } from './farm';
import { Stable } from './stable';

export class xSurvey {
  id: string = null;
  answer?: SurveyAnswerResponse = null;
  template: SurveyTemplate = null;
  userCreated: number = null;
  companyIdCreated: number = null;
  companyIdAssignee: number = null;
  owners: number[] = null;
  referenceId: number = null;
  dateCreated: Date = null;
  companyIdAnswerLastModify: number = null;
  userIdLastAnswerModify: number = null;
  lastModify: Date = null;
  status: string = null;
  module: string = null;
  isOwner: boolean = null;
  entity: number = null;
  entityType: string = null;
  entityDetail: EntityDetail = null;
  result?: number = null;
  minResultCalc?: number = null;
  maxResultCalc?: number = null;
  chainKey?: string = null;
  hasCalculated?: boolean = null;
  isCompliant?: boolean = null;
  entityName?: string = null;
}

export class EntityDetail {
  name: string = null;
  commodityTranslatedKey: string = null;
  fieldName: string = null;
}

export class xSurveyForTableView extends xSurvey {
  certifiedUserName?: string = null;
  certifierUserName?: string = null;
  auditorUserRole?: string = null;
  certifierOrigin?: string = null;
  certifiedUserRole?: string = null;
  action?: string = null;
}

export class SurveyTemplate {
  id: string = null;
  title: string = null;
  questions: SurveyQuestion[] = [];
  sections: SurveySection[] = [];
}

export class SurveyTemplateResponse {
  userCreated: any = null;
  dateCreated: string = null;
  lastModify: string = null;
  referenceId: any = null;
  id: any = null;
  title: string = null;
  template: SurveyTemplate = new SurveyTemplate();
  minResultCalc?: number = null;
  maxResultCalc?: number = null;
  scoreList: SurveyTemplateScoresSections[] = null;
  calcId: boolean = null;
}

export class SurveyTemplateScoresSections {
  categoryId: string = null;
  min: number = null;
  max: number = null;
}

export class SurveyAnswer {
  questionId?: string = null;
  localId?: string = null;
  questionIdTree?: string = null;
  value?: any = null;
  note?: string = null;
  options?: SurveyAnswerOption[] = [];
  ruleOriginIds?: string[] = [];
  nestingLevels?: string = null;
  parentSectionLocalId?: string = null;
  categoryCalcId?: string = null;
  lineageCalcId?: string[] = []; // id used for scores purposes: it is assigned to entities multiplied by entities multiplied themselves
}

export class SurveyAnswerNode {
  parent?: SurveyAnswerNode = null;
  data: SurveyAnswer = new SurveyAnswer();
  children?: SurveyAnswerNode[] = [];
}

export class SurveyQuestion {
  id: string = null;
  // the local id is used to uniquely identify the question after the moltiplications
  localId: string = null;
  categoryName: string = null;
  categoryId: string = null;
  subcategoryName: string = null;
  subcategoryId: string = null;
  groupName: string = null;
  groupId: any = null;
  index: number = null;
  title: string = null;
  description: string = null;
  generalType: string = null;
  specificType: string = null;
  show: boolean = true;
  required: boolean = false;
  readOnly: boolean = false;
  udm: string = null;
  allLogicIds: string[] = [];
  answerOptions: SurveyOption[] = [];
  answer?: SurveyAnswerNode = new SurveyAnswerNode();
  validation: FormGroup = new FormGroup({});
  dataTransferId?: string = null;
  showHideId?: string = null;
  isReading?: boolean = false;
  createTree?: boolean = false;
  toBeDisplayed?: boolean = false;
  // the parent section of the question for the template
  parentSection: SurveySectionInfo = null;
  rulesParentQuestion: SurveyQuestionInfo = null;
  multiplicationIndex: number = null;
  ruleOriginIds?: string[] = [];
  nestingLevels?: string = null;
}

export class SurveyQuestionInfo {
  id: string = null;
  title: string = null;
  localId: string = null;
  multiplicationIndex: string = null;
  nestingLevels?: string = null;
}

export class SurveyAnswerResponse {
  companyIdCreated: number = null;
  companyIdLastModify: number = null;
  dateCreated: string = null;
  formModel: string = null;
  id: string = null;
  lastModify: string = null;
  structure: SurveyAnswerNode[] = null;
  surveyId: string = null;
  userCreated: number = null;
  userIdLastModify: number = null;
}

export class SurveyOption {
  id: string = null;
  value: any = null;
  note: string = null;
  logicIds: string = null;
}

export class SurveyAnswerRequest {
  answers: SurveyAnswerNode[] = [];
  formModel: string = null;
}

export class SurveyAnswerOption {
  id: string = null;
  value: any = null;
  logicIds?: string = null;
}

export class SurveyAnswerPost {
  answers: SurveyAnswerNode[] = [];
  formModel: string = null;
  surveyStatus?: string = null;
}

export class SurveyAnswerSectionScore {
  lastModify: Date = null;
  id: string = null;
  survey: string = null;
  category: string = null;
  categoryId: string = null;
  categoryCalcId: string = null;
  result: number = null;
  suggestion: any[] = null;
  warning: any[] = null;
  consultant: any[] = null;
}

export class SurveySectionInfo {
  id: string = null;
  name: string = null;
  nestingLevels?: string = null;
  // tells the index coming from the multiplication,
  // used to give the parent name later in the duplication process
  multiplicationIndex: number = null;
}

export class SurveySection {
  id: string = null;
  name: string = null;
  type: string = null;
  show: boolean = true;
  isValid?: boolean = false;
  collapsed: boolean = true;
  // Tells which is the parent section, is not related
  // to the node structure needed for posting the answers
  parentSection: SurveySectionInfo = new SurveySectionInfo();
  rulesParentQuestion: SurveyQuestionInfo = new SurveyQuestionInfo();
  localId: string = null;
  questions?: SurveyQuestion[] = [];
  children?: SurveySection[] = [];
  multiplicationIndex: number = null;
  ruleOriginIds?: string[] = [];
  nestingLevels?: string = null;
  isReading?: boolean = false;
  showHideId?: string = null;
  categoryCalcId?: string = null;
  lineageCalcId?: string[] = []; // id used for scores purposes: it is assigned to entities multiplied by entities multiplied themselves
}

export class SurveyFilters {
  years: number[] = [];
  auditorUserRole: string[] = [];
  certifiedUserIds: string[] = [];
  auditorUserIds: string[] = [];
  types: string[] = [];
  schemas: string[] = [];
  results: string[] = [];
}

export class SurveyResponse {
  objList: SurveyTemplate[];
  pagination: Pagination;
}

export class SurveyRulesResponse {
  id: string = null;
  name: string = null;
  templateId: string = null;
  logic: SurveyRule[] = [];
}

export class SurveyRule {
  id: string = null;
  questionId: string = null;
  answerId: string = null;
  action: string = null;
  coefficient?: number = null;
  entityRelated: string = null;
  entityRelatedIds: string[] = [];
}

export interface FarmCompareDropdown {
  id: number;
  name: string;
  farmData: Farm;
}

export interface EntityCompareDropdown {
  id: string;
  name: string;
  entityId: number;
  entityType: string;
  surveyData: xSurvey;
  cropData?: Crop;
  stableData?: Stable;
}

export class SurveyScoreDetailsLight {
  name: string;
  categoryId: string;
  score: number | string;
  maxScore: number;
}

export class SurveyScoreFeedback {
  categoryName: string;
  description: string;
}

export class SurveyMultiFarmFilter {
  multiFarmFilter: {
    companyIds: number[];
  };
}

export const surveyModuleType = {
  SURVEY: 'SURVEY',
  AUDIT: 'AUDIT',
};

export const SurveyTypes = {
  RADIO: 'radio',
  SINGLE_CHECKBOX: 'singleCheckbox',
  MULTI_CHECKBOX: 'multiCheckbox',
  TOGGLE: 'toggle',
  NUMBER: 'number',
  DATE: 'date',
  DATETIME: 'datetime',
  TIME: 'time',
  TEXT: 'text',
  TEXT_LONG: 'textLong',
  SINGLE_DROPDOWN: 'singleDropdown',
  MULTI_DROPDOWN: 'multiDropdown',
  SINGLE_DROPDOWN_NUMBER: 'singleDropdown_number',
};

export const surveyRulesActions = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  DISPLAY_TIMES: 'DISPLAYTIMES',
  GET_VALUE_FROM: 'GETVALUEFROM',
};

export const surveyItemTypes = {
  SURVEY: 'survey',
  SECTION: 'section',
  SUBSECTION: 'subsection',
  GROUP: 'group',
  QUESTION: 'question',
};

export const surveyStatus = {
  TODO: 'TODO',
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED',
  CALCULATED: 'CALCULATED',
};

export const surveyActions = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
};

export const surveyActors = {
  OWNER: 'OWNER',
  ASSIGNEE: 'ASSIGNEE',
  ALL: 'ALL',
};

export const surveyEntityType = {
  FARM: 'FARM',
  STABLE: 'STABLE',
  CROP: 'CROP',
};
